import { ReferralStats, WhitelistStatus } from '@crypto-trading/common/browser';
import { ApiClientManager } from '@/utils/api-client-factory';

/**
 * Referral API functions - organized by domain
 */

// Removed client-side verify; use single join call instead

/**
 * Check if user is already referred
 */
export const isUserReferred = async (telegramId: string): Promise<boolean> => {
  return ApiClientManager.getReferralClient().isUserReferred(telegramId);
};

/**
 * Process new user with referral code (backed by unified join)
 */
export const joinWithReferral = async (
  telegramId: string,
  referralCode?: string
): Promise<void> => {
  await ApiClientManager.getReferralClient().joinWithReferral(
    telegramId,
    referralCode
  );
};

/**
 * Get referral statistics for a user
 */
export const getReferralStats = async (telegramId: string): Promise<ReferralStats> => {
  return ApiClientManager.getReferralClient().getReferralStats(telegramId);
};

/**
 * Get whitelist status for a user
 */
export const getWhitelistStatus = async (telegramId: string): Promise<WhitelistStatus> => {
  return ApiClientManager.getReferralClient().getWhitelistStatus(telegramId);
};



